// Pliki (zdjęcia, plany, podpisy, protokoły) między telefonami: wysyłka tego, czego serwer jeszcze nie ma, i pobranie tego,
// na co wskazują zdarzenia innych urządzeń. Plik leży na serwerze pod swoim skrótem SHA-256: nie da się go nadpisać innym plikiem,
// a pobrany plik z innym skrótem odrzucamy (uszkodzony albo podmieniony). Bez IndexedDB, żeby dało się to sprawdzić w teście.

const hex = (buf) => [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');

/** doWyslania: skróty plików z tego urządzenia, których serwer jeszcze nie potwierdził; czytaj(hash) → { dane, typ } | null; oznacz(hash). */
export async function wyslijPliki(adapter, { doWyslania, czytaj, oznacz, limit = 30 }) {
  let wyslane = 0;
  for (const h of doWyslania.slice(0, limit)) {
    const f = await czytaj(h); if (!f) continue;
    const r = await adapter.wyslijPlik(h, f.dane, f.typ);
    if (!r.ok) return { wyslane, powod: r.powod, zostalo: doWyslania.length - wyslane };
    await oznacz(h); wyslane++;
  }
  return { wyslane, zostalo: doWyslania.length - wyslane };
}

/** potrzebne: skróty, na które wskazują zdarzenia; mam(hash) → bool; zapisz(hash, dane, typ). Plik, którego serwer nie ma
 *  (drugi telefon jeszcze go nie wysłał), czeka do następnej synchronizacji. */
export async function pobierzPliki(adapter, { potrzebne, mam, zapisz, limit = 20 }) {
  let pobrane = 0, brak = 0; const uszkodzone = [];
  for (const h of potrzebne) {
    if (pobrane + brak + uszkodzone.length >= limit) break;
    if (await mam(h)) continue;
    const r = await adapter.pobierzPlik(h);
    if (!r.ok) { if (r.brak) { brak++; continue; } return { pobrane, brak, uszkodzone, powod: r.powod }; }
    if (hex(await crypto.subtle.digest('SHA-256', r.dane)) !== h) { uszkodzone.push(h); continue; }
    await zapisz(h, r.dane, r.typ); pobrane++;
  }
  return { pobrane, brak, uszkodzone };
}
